import React, { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import AppBody from "../../components/AppBody";
import { useDispatch, useSelector } from "react-redux";
import { getQuestionBank } from "../../../actions/learning_provider/question/question_bank_action";

const ShowQuestionBank = () => {
  const state = useSelector((state) => state.questionBankReducer);
  const dispatch = useDispatch("");
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    dispatch(getQuestionBank());
  }, []);

  const searchQuestion = () => {
    dispatch(getQuestionBank({ search: searchText }));
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/question-bank/show"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Question Bank
              </h4>
              <div className="col text-right pr-0">
                <Link to={"/question-bank/add"}>
                  <a
                    className="line-height-36 custom-icon mr-2"
                    title="Add Question Bank"
                  >
                    <i className="feather-plus-circle"></i>
                  </a>
                </Link>
              </div>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="row">
                <div className="col-lg-2 mb-3" />
                <div className="col-lg-6 mb-3">
                  <input
                    type="text"
                    onChange={(e) => {
                      e.target.value
                        ? setSearchText(e.target.value)
                        : dispatch(getQuestionBank({ search: "" }));
                    }}
                    className="form-control ad-search-cer-tb"
                  />
                </div>
                <div className="col-lg-2 mb-3">
                  <button
                    type="button"
                    className="btn  btn-common ad-serach-cer-btn"
                    onClick={() => searchQuestion()}
                  >
                    Search
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Identified</th>
                      <th>Category</th>
                      <th>Question Type</th>
                      <th>Question</th>
                      <th>Correct Option</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.language_identified}</td>
                          <td>{li.question_category}</td>
                          <td>{li.question_type}</td>
                          <td>{li.question}</td>
                          <td>{li.correct_option}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ShowQuestionBank;
